import React from "react";

const WOLF_SYMBOL = "/wolf-mark-gold.png";

export default function WolfMark({ className = "w-8 h-8", glow = true, alt = "WOLF" }) {
  return (
    <img
      src={WOLF_SYMBOL}
      alt={alt}
      data-testid="wolf-symbol"
      className={`${className} ${glow ? "eye-pulse" : ""} select-none pointer-events-none`}
      draggable={false}
    />
  );
}

export const WOLF_SYMBOL_URL = WOLF_SYMBOL;
